import { Em, Flex, Text } from '@radix-ui/themes';

export interface DataCardLayoutProps {
    title: string;
    content: string | number;
    subTitle?: string;
}

export const DataCardLayout = ({
    title,
    content,
    subTitle,
}: DataCardLayoutProps) => (
    <Flex
        direction={'column'}
        align={'start'}
        justify={'center'}
        width={'100%'}
        mx={'2'}
    >
        <Text size={'3'} color={'gray'} weight={'medium'}>
            {title}
        </Text>

        <Text size={'7'} weight={'bold'} my={'2'} wrap={'nowrap'}>
            {content}
        </Text>

        {subTitle && (
            <Text size={'1'} color={'gray'}>
                <Em>{subTitle}</Em>
            </Text>
        )}
    </Flex>
);
